import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaginatorComponent} from './paginator.component';
import {MatSelectModule} from '@angular/material/select';
import {PortalSelectModule} from '../portal-select/portal-select.module';

@NgModule({
  declarations: [PaginatorComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    PortalSelectModule
  ],
  exports: [
    PaginatorComponent
  ]
})
export class PaginatorModule {
}
